import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, Container, Image } from 'react-bootstrap';
import logo from '../Assets/Images/logo-Dark-blue.png'
// import HomePage from '../Layout/';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faUser } from "@fortawesome/free-regular-svg-icons";
import {faPowerOff} from "@fortawesome/free-solid-svg-icons";
// import SupportHeader from './SupportHeader';
import Typography from '@mui/material/Typography'

// Header Component
const Header = () => {
  const [activeLink, setActiveLink] = useState('home');
  const [isSticky, setIsSticky] = useState(false);

  const handleNavClick = (link) => {
    console.log(link)
    setActiveLink(link);
  };
  useEffect(() => {
    const handleScroll = () => {
      if(window.scrollY > 300){
        setIsSticky(true)
      }else{
        setIsSticky(false)
      }
    }
    window.addEventListener('scroll', handleScroll)
      return() => {window.removeEventListener('scroll', handleScroll)}
    
  }, [])
  return (
    <>
    {/* <SupportHeader /> */}
      <Navbar className={`cstHeader ${isSticky ? 'sticky' : ''} `}  expand="lg">
        <Container>
          <Navbar.Brand as={Link} to="/" className='cstLogo'>
           <Image src={logo} className='img-fluid'></Image>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className='justify-content-between'>
          <Nav className="navLinkWrap">
            <Nav.Link
              as={Link}
              to="/"
              className={activeLink === 'home' ? 'active' : ''}
              onClick={() => handleNavClick('home')}
            >
              Home
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/about"
              className={activeLink === 'about' ? 'active' : ''}
              onClick={() => handleNavClick('about')}
            >
              About
            </Nav.Link>
            {/* <Nav.Link
              as={Link}
              to="/contact"
              className={activeLink === 'contact' ? 'active' : ''}
              onClick={() => handleNavClick('contact')}
            >
              Contact
            </Nav.Link> */}
            <Nav.Link
              as={Link}
              to="/booknow"
              className={activeLink === 'book-now' ? 'active' : ''}
              onClick={() => handleNavClick('book-now')}
            >
              Book Now
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/news"
              className={activeLink === 'news' ? 'active' : ''}
              onClick={() => handleNavClick('news')}
            >
              News
            </Nav.Link>
            <NavDropdown title="Services" id="basic-nav-dropdown" className='cstNavDrop'>
              <NavDropdown.Item
                as={Link}
                to="/service1"
                onClick={() => handleNavClick('service1')}
                className={activeLink === 'service1' ? 'active' : ''}
              >
                Flight Status
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/dashboard"
                className={activeLink === 'dashboard' ? 'active' : ''}
                onClick={() => handleNavClick('dashboard')}
              >
                Destinations
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
          <Nav.Link
            as={Link}
            to="/auth"
            className={`ms-0 ms-lg-5 loginIcon d-flex gap-1 align-items-center ${activeLink === 'user' ? 'active' : ''}`}
            onClick={() => handleNavClick('user')}
          >
            <FontAwesomeIcon icon={faPowerOff} /> <Typography component='span' style={{fontWeight: '600', fontSize: '18px'}}>Login</Typography>
          </Nav.Link>
        </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};


export default Header;